

const Expertise = () => {


  const services = [
    {
      icon: 'fa-chart-line',
      title: "Investment Banking",
      items: [
        "Fundraising & Capital Raising",
        "Financial Modeling & Valuation",
        "Investment Marketing Documents (Pitch Decks, IMs)",
        "Investor Connect & Roadshow Support",
        "Post-Transaction Integration",
        "Debt Advisory & Structuring (term loans, credit facilities)",
        "Capital Structure Advisory",
        "Valuation Services"
      ],
      image: "https://images.unsplash.com/photo-1450101499163-c8848c66ca85?ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=80"
    },
    {
      icon: 'fa-handshake',
      title: "Mergers & Acquisitions",
      items: [
        "Deal Origination to Closure Support",
        "Buy-side & Sell-side Advisory",
        "Strategic Fit & Synergy Analysis",
        "Post-Merger Integration Planning & Execution",
        "Due Diligence Coordination (Financial, Legal, Commercial)",
        "Transaction Support Services",
        "Valuation & Deal Structuring"
      ],
      image: "https://images.unsplash.com/photo-1554224155-6726b3ff858f?ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=80"
    },
    {
      icon: 'fa-briefcase',
      title: "Private Equity",
      items: [
        "Deal Evaluation & Due Diligence",
        "Portfolio Company Value Creation",
        "Exit Strategy Planning & Execution",
        "Accounting Integration Support",
        "Consolidation & Venture Structuring",
        "Investor Committee Compliance",
        "Performance Monitoring & Reporting",
        "Fund Administration Support"
      ],
      image: "https://images.unsplash.com/photo-1521791136064-7986c2920216?ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=80"
    },
    {
      icon: 'fa-piggy-bank',
      title: "Investment & Wealth",
      items: [
        "Equity Research & Analysis",
        "Portfolio Review & Optimization",
        "Techno-Funda Research (Technical & Fundamental)",
        "Asset Allocation Strategy",
        "Risk Management & Hedging",
        "Retirement & Estate Planning",
        "Tax-Efficient Investment Strategies",
        "Wealth Preservation Planning"
      ],
      image: "https://images.unsplash.com/photo-1553729459-efe14ef6055d?ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=80"
    },
    {
      icon: 'fa-rocket',
      title: "Corporates & Startups",
      items: [
        "Fractional CFO Services",
        "Business Plan Development & Feasibility Studies",
        "Budgeting, Forecasting & Financial Modeling",
        "Working Capital Management",
        "Grant & Incentive Advisory",
        "Financial Process Optimization",
        "Startup Mentorship & Advisory",
        "Growth Strategy Development"
      ],
      image: "https://images.unsplash.com/photo-1467232004584-a241de8bcf5d?ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=80"
    },
    {
      icon: 'fa-microchip-ai',
      title: "AI Integration for Finance & Accounting",
      items: [
        "AI and automation-powered Financial Modeling & Analysis",
        "AI in Investment Research & Portfolio Management",
        "Automated Compliance & Regulatory Reporting",
        "AI for Corporate Finance & CFO Operations",
        "AI-Driven Content & Investor Communication",
        "Chatbots & Virtual Assistants for Financial Operations"
      ],
      image: "https://images.unsplash.com/photo-1467232004584-a241de8bcf5d?ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=80"
    }
  ];

  return (
  <section id="services" className="py-20 bg-gray-50">
      <div className="container mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold font-serif text-gray-900 mb-4">Our Expertise</h2>
          <div className="w-20 h-1 bg-gradient-to-r from-blue-600 to-green-500 mx-auto rounded-full"></div>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 mx-auto">
          {services.map((service, index) => (
            <div key={index} className="bg-white p-8 rounded-xl shadow-md hover:shadow-lg transition duration-300">
              <div className="flex  items-center gap-6">
              <div className="bg-blue-100 p-4 rounded-lg inline-block mb-3">
                <i className={`fas ${service.icon} text-blue-600 text-2xl`}></i>
              </div>
                <h3 className="text-xl font-semibold text-gray-900 mb-3">{service.title}</h3>
              </div>
              <ul className="space-y-2 text-gray-600">
                {service.items.map((item, i) => (
                  <li key={i} className="flex items-start">
                    <span className="text-blue-600 mr-2">•</span>
                    <span>{item}</span>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Expertise;